import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { QuizzApiService } from './quizz-api.service';
import { QuizzEffects } from './quizz.effects';
import { quizzInitialState, quizzReducer } from './quizz.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('quizz', quizzReducer, {
      initialState: quizzInitialState
    }),
    EffectsModule.forFeature([QuizzEffects])
  ],
  providers: [QuizzApiService]
})
export class QuizzStoreModule {}
